import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private authService = inject(AuthService);
  // FIX: Explicitly typed `router` to resolve a type inference issue where the compiler
  // treated it as `unknown`, preventing access to its methods.
  private router: Router = inject(Router);

  constructor() {
    console.log('[AppComponent] Constructor: Setting up effect for initial navigation.');
    effect(() => {
      if (this.authService.initialSessionResolved()) {
        console.log('[AppComponent] Auth service has resolved initial session. Triggering initial navigation.');
        // Now that Supabase has had a chance to process the URL, we can safely start the Angular router.
        // To manually trigger the initial navigation when using `withDisabledInitialNavigation`,
        // we navigate to the current URL from the hash fragment.
        this.router.navigateByUrl(window.location.hash.substring(1) || '/');
      } else {
        console.log('[AppComponent] Effect ran, but initial session not yet resolved.');
      }
    });
  }
}
